/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Where an invoice stands, computed by the server so the dashboard never has to compare due dates itself. Overdue means past its due date and not disputed - a dispute takes an invoice out of the overdue queue, matching the rule that gates booking. Note this is not the same question as blockingBooking, which additionally requires the instant-pay grace period to have run out.
 * @export
 */
export const InvoiceStanding = {
    Open: 'Open',
    Overdue: 'Overdue',
    Disputed: 'Disputed',
    PaymentSent: 'PaymentSent',
    Paid: 'Paid',
    Voided: 'Voided'
} as const;
export type InvoiceStanding = typeof InvoiceStanding[keyof typeof InvoiceStanding];


export function instanceOfInvoiceStanding(value: any): boolean {
    for (const key in InvoiceStanding) {
        if (Object.prototype.hasOwnProperty.call(InvoiceStanding, key)) {
            if (InvoiceStanding[key as keyof typeof InvoiceStanding] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InvoiceStandingFromJSON(json: any): InvoiceStanding {
    return InvoiceStandingFromJSONTyped(json, false);
}

export function InvoiceStandingFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceStanding {
    return json as InvoiceStanding;
}

export function InvoiceStandingToJSON(value?: InvoiceStanding | null): any {
    return value as any;
}

export function InvoiceStandingToJSONTyped(value: any, ignoreDiscriminator: boolean): InvoiceStanding {
    return value as InvoiceStanding;
}

